import isEqual from 'lodash/isEqual';

const titleTag = document.querySelector('title');
const { dataLayer, location } = window;

export default {
  current: {
    pathname: '',
    title: '',
  },

  set({
    pathname,
    title,
  } = {}) {
    const draft = {
      path: pathname || location.pathname,
      title: title
        ? `${title} | Tai Ping Carpets`
        : 'Tai Ping Carpets',
    };

    if (isEqual(this.current, draft)) return;

    this.current = draft;

    if (titleTag) {
      titleTag.innerHTML = draft.title;
    }

    if (dataLayer) {
      dataLayer.push({
        event: 'pageview',
        pagePath: draft.pathname,
        pageTitle: draft.title,
      });
    }
  },
};
